module.exports = __webpack_public_path__ + "static/media/egg-toast.864372c2.jpg";